<template>
  <div class="jc-center">
    <div class="content">
      <div class="jc-sb">
        <div class="flex title">
          <img :src="info.picture" />
          <h2>{{ info.title }}</h2>
        </div>
        <a class="more cp">更多 »</a>
      </div>
      <div class="flex wrap">
        <div class="good cp" v-for="(item, index) in list" :key="index">
          <div class="goodItem">
            <img :src="item.schoolPageInfo.logo" />
            <div class="info">
              <div class="title">{{ item.schoolPageInfo.name }}</div>
              <div class="jc-sb">
                <div class="left">{{ item.schoolPageInfo.lesson }}课时</div>
                <div class="right">
                  ￥ <span>{{ item.schoolPageInfo.price }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: { info: Object },
  data() {
    return {
      list: [],
    };
  },
  watch: {
    info: {
      handler(val) {
        this.list = val.wxSchoolPageItemList;
      },
      deep: true,
    },
  },
  mounted() {
    this.list = this.info.wxSchoolPageItemList;
  },
};
</script>
<style lang="less" scoped>
.jc-center {
  margin-top: 30px;
}
.content {
  width: 1200px;
}

.title img {
  width: 24px;
  height: 24px;
  margin-right: 6px;
}
.title h2 {
  font-size: 24px;
  font-weight: 600;
}
.more {
  color: #8c8c8c;
  font-size: 14px;
}
.good {
  margin-right: 24px;

  &:nth-child(4n + 4) {
    margin-right: 0;
  }
}
.goodItem {
  width: 282px;
  height: 290px;
  margin-top: 8px;
  border-radius: 6px;
  &:hover {
    color: #0a58ca;
    animation: test 0.4s;
    animation-fill-mode: forwards;
  }
  @keyframes test {
    from {
      margin-top: 8px;
      box-shadow: 0 0 0 0 rgb(0 0 0 / 10%);
    }
    to {
      margin-top: 2px;
      box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    }
  }
  img {
    border-radius: 6px 6px 0 0;
    width: 100%;
    height: 210px;
  }
}

.info {
  padding: 10px;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    font-weight: bolder;
  }
  .left {
    color: #8c8c8c;
    font-size: 12px;
  }
  .right {
    color: red;
    span {
      font-size: 20px;
      font-weight: 600px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/designPage/template/goods/goods1/index.vue